import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { session } from './stores/session'
import { theme } from './stores/theme'
import { toast } from './stores/toast'
import { getToken, onUnauthorized } from './api/http'
import './assets/main.css'

// 401 « unauthenticated » (jeton expiré ou révoqué) ou compte désactivé :
// on vide la session et on renvoie vers la connexion.
onUnauthorized((error) => {
  // Connexion en cours ou restauration au démarrage : ces écrans gèrent l'erreur eux-mêmes.
  if (!session.loaded || (!session.isAuthenticated && !getToken())) return
  session.clear()
  if (error.code === 'account_disabled') toast.error(error.message)
  const current = router.currentRoute.value
  router.replace({
    name: 'login',
    query: { ...(current.meta.guest || current.meta.public ? {} : { redirect: current.fullPath, expired: '1' }) }
  })
})

const app = createApp(App)
app.config.globalProperties.$session = session
app.config.globalProperties.$theme = theme
app.use(router)
theme.init() // avant le montage : le premier rendu est déjà dans le bon thème
app.mount('#app')
